import axiosInstance from "auth/FetchInterceptor";
import {
  V2_CUSTOMER_API,
  V2_GET_ALL_CUSTOMER_API,
  V2_CUSTOMER_SUMMARY_API,
  V2_CUSTOMER_EXPORT_EXCEL,
  V2_CUSTOMER_EXPORT_EXCEL_HISTORY,
} from "constants/ApiConstant";
const CustomerService = {};

CustomerService.getAllCustomer = function (data) {
  return axiosInstance.post(V2_GET_ALL_CUSTOMER_API, data);
};

CustomerService.getCustomerById = function (id) {
  return axiosInstance.get(`${V2_CUSTOMER_API}/${id}`, null);
};

CustomerService.getCustomerSummary = function () {
  return axiosInstance.get(V2_CUSTOMER_SUMMARY_API, null);
};

CustomerService.exportExcel = function (data) {
  return axiosInstance.post(V2_CUSTOMER_EXPORT_EXCEL, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

CustomerService.exportExcelHistory = function (data) {
  return axiosInstance.post(V2_CUSTOMER_EXPORT_EXCEL_HISTORY, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

export default CustomerService;
